import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/pt";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import dayOfYear from "dayjs/plugin/dayOfYear";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isoWeek from "dayjs/plugin/isoWeek";
import weekDay from "dayjs/plugin/weekday";
import isBetween from "dayjs/plugin/isBetween";
import { I18N_FALLBACK_LOCALE } from "@/plugins/i18n";

dayjs.extend(isoWeek);
dayjs.extend(weekDay);
dayjs.extend(dayOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(LocalizedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

dayjs.locale(I18N_FALLBACK_LOCALE);

export { dayjs };
